var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.icon,_vm._b({tag:"component",class:`lucide-icon-${_vm.size}`,attrs:{"size":_vm.standardized_size}},'component',_vm.svg_props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }